import { graphql, useStaticQuery } from 'gatsby'

const query = graphql`
	query UseAllDocumentsQuery {
		allMdx(sort: { fields: slug }) {
			edges {
				node {
					slug
					body
					tableOfContents(maxDepth: 6)
					headings {
						value
						depth
					}
					frontmatter {
						title
						documentTitle
						# tag
						# heading
						tags
						description
						draft
						hidden
						section
						divider
						icon {
							publicURL
						}
						# cover {
						# 	publicURL
						# }
						virtual
						fullWidth
						hideTopSection
						switcherData {
							uses
							id
							label
						}
						switcherInit {
							uses
							default
						}
						customPagination {
							prev {
								url
								title
							}
							next {
								url
								title
							}
						}
						releaseDate
						metaTitle
						metaDescription
						# langSwitcher
						# dbSwitcher
					}
					fields {
						slug
						modSlug
					}
				}
			}
		}
	}
`

const useAllDocumentsQuery = () => {
	const { allMdx } = useStaticQuery(query)
	return allMdx
}

export default useAllDocumentsQuery
